import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";
import { compressImage, blobToBase64 } from "../utils/imageCompression";
import type {
  SetUserPhotoOnBehalfInput,
  SetUserPhotoOnBehalfResponse,
} from "@event-planner/shared";

/**
 * Thin wrapper around the `setUserPhotoOnBehalf` callable. Handles client-side
 * compression to the headshot preset, base64 encoding, and the callable
 * invocation. Supports both user photos and contact photos.
 */

const setUserPhotoOnBehalfCallable = httpsCallable<
  SetUserPhotoOnBehalfInput,
  SetUserPhotoOnBehalfResponse
>(functions, "setUserPhotoOnBehalf");

export async function setUserPhotoOnBehalf(
  eventId: string,
  userId: string,
  file: File,
): Promise<SetUserPhotoOnBehalfResponse> {
  const { blob, contentType } = await compressImage(file, "headshot");
  const imageBase64 = await blobToBase64(blob);
  const result = await setUserPhotoOnBehalfCallable({
    eventId,
    userId,
    imageBase64,
    contentType,
  });
  return result.data;
}

export async function setContactPhotoOnBehalf(
  contactId: string,
  file: File,
): Promise<SetUserPhotoOnBehalfResponse> {
  const { blob, contentType } = await compressImage(file, "headshot");
  const imageBase64 = await blobToBase64(blob);
  const result = await setUserPhotoOnBehalfCallable({
    contactId,
    imageBase64,
    contentType,
  });
  return result.data;
}
